/* Ever Near: delivery estimate and the home quantity stepper. */
(function () {
  function fmt(d) {
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  }
  function eta() {
    var now = Date.now();
    document.querySelectorAll('[data-en-eta]').forEach(function (el) {
      var from = el.querySelector('[data-en-eta-from]');
      var to = el.querySelector('[data-en-eta-to]');
      if (from) from.textContent = fmt(new Date(now + 6 * 86400000));
      if (to) to.textContent = fmt(new Date(now + 10 * 86400000));
    });
  }
  /* first bracelet at full price, each extra one at data-extra (pence) */
  function qty() {
    document.querySelectorAll('[data-en-qty]').forEach(function (box) {
      var input = box.querySelector('input');
      var form = box.closest('form');
      var total = form && form.querySelector('[data-en-total]');
      function show() {
        if (!total) return;
        var n = Math.max(1, parseInt(input.value, 10) || 1);
        total.textContent = '£' + ((+total.dataset.first + (n - 1) * +total.dataset.extra) / 100).toFixed(2);
      }
      box.addEventListener('click', function (e) {
        var b = e.target.closest('[data-step]');
        if (!b) return;
        input.value = Math.min(9, Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10)));
        show();
      });
      input.addEventListener('input', show);
    });
  }
  function run() { eta(); qty(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
